import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../Pages/home/Index";
import MainLayout from "../Layouts/MainLayout";
import AdminLayout from "../theme/Admin/Toolpad";
import ProtectedRoute from "../hooks/ProtectedRoute";

import { Login } from "../Pages/Login/Index";
import { QuienesSomos } from "../Pages/quienessomos/Index";
import { NoticiasPages } from "../Pages/Noticias";
import { Horarios } from "../Pages/Horarios";
import { ReglamentoPages } from "../Pages/reglamento/Index";
import { ContactoPages } from "../Pages/contacto/Index";
import { Comunicado } from "../Pages/comunicado/ComunicadoIndex";
import { SubNoticia } from "../Pages/Noticias/SubIndex";
import { AdmisionPages } from "../Pages/Admision/Index";
import { Dashboard } from "../Pages/Admin/Dashboard";
/* admin */
import Noticias from "../Pages/Admin/Noticias";
import { Banner } from "../Pages/Admin/Banner";
import { Horario } from "../Pages/Admin/Horarios";
import { Documentos } from "../Pages/Admin/Documentos";
import { Comunidad } from "../Pages/Admin/comunidad";
import { Agenda } from "../Pages/Admin/Agenda";


const AppRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
           <Route path="/quienes-somos" element={<QuienesSomos />} />
           <Route path="/login" element={<Login />} />
           <Route path="/noticias" element={<NoticiasPages />} />
            <Route path="/horarios" element={<Horarios/>} />
             <Route path="/reglamentos" element={<ReglamentoPages/>} />
              <Route path="/comunicate-con-nosotros" element={<ContactoPages/>} />
              <Route path="/agenda-comunicaciones" element={<Comunicado/>} />
               <Route path="/admision" element={<AdmisionPages/>} />
              <Route
            path="/noticias/:titulo"
            element={<SubNoticia />}
          />

          
        </Route> 
        
         <Route element={<ProtectedRoute />}>

                    <Route
                        path="/admin/antilen"
                        element={
                            <AdminLayout>
                                <Dashboard />
                            </AdminLayout>
                        }
                    />

                     <Route
                        path="/admin/noticias"
                        element={
                            <AdminLayout>
                                <Noticias />
                            </AdminLayout>
                        }
                    />
                     <Route
                        path="/admin/banner"
                        element={
                            <AdminLayout>
                                <Banner />
                            </AdminLayout>
                        }
                    />

                    <Route
                        path="/admin/Horarios"
                        element={
                            <AdminLayout>
                                <Horario />
                            </AdminLayout>
                        }
                    />
                     <Route
                        path="/admin/reglamentos"
                        element={
                            <AdminLayout>
                                <Documentos/>
                            </AdminLayout>
                        }
                    />
                    <Route
                        path="/admin/comunidad"
                        element={
                            <AdminLayout>
                                <Comunidad/>
                            </AdminLayout>
                        }
                    />
                     <Route
                        path="/admin/agenda"
                        element={
                            <AdminLayout>
                                <Agenda/>
                            </AdminLayout>
                        }
                    />

                </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;